<p-dialog
  *ngIf="visible"
  header="{{ header }}"
  [style]="{ width: '425px' }"
  [(visible)]="visible"
  [modal]="modal"
  [closeOnEscape]="false"
  (onHide)="onHide()"
  appendTo="body"
  [resizable]="false"
  [closable]="!loading"
  styleClass="dialog alert-dialog {{ 'alert-dialog--' + severityColor }}"
>
  <app-change-password-form-group
    (loadingChanged)="loading = $event"
    *ngIf="!saved"
    [userKey]="userKey"
    (passwordChanged)="onPasswordChanged()"
    [localUser]="localUser"
  ></app-change-password-form-group>
  <p *ngIf="saved" translate>Password succesfully changed</p>
  <p-footer>
    <button
      class="button button--outline"
      kpdHotkey="esc"
      icon="fa-close"
      (click)="close('cancel')"
      *ngIf="!saved && !loading"
    >
      {{ cancelLabel }}
    </button>
    <button
      *ngIf="!saved"
      class="button button--main"
      kpdHotkey="enter"
      icon="fa-check"
      (click)="onSubmit()"
      [disabled]="loading"
    >
      <span *ngIf="!saved && !loading">{{ verifyLabel }}</span
      ><span *ngIf="!saved && loading" translate>Processing</span>
    </button>
    <button class="button button--main" kpdHotkey="enter" (click)="close()" *ngIf="saved" translate>close</button>
  </p-footer>
</p-dialog>
